import Progress from 'antd/es/progress'
import { HStack, Icon, T, Tooltip } from 'govwell-ui'
import { getValueOfTailwindVariable } from 'govwell-ui/utils'

import { IconOnlyButton } from 'src/components/shared/StyledComponents'
import { formatFileProgress } from 'src/utils/file'

type Props = {
  fileName: string
  onRemove: () => void
  progress: number
}
export const Uploading = ({ fileName, onRemove, progress }: Props) => {
  return (
    <HStack justify="space-between">
      <T.Body className="flex-1 text-left" maxLines={1}>
        {fileName}
      </T.Body>
      <HStack className="flex-0">
        <Progress
          type="circle"
          percent={formatFileProgress(progress)}
          size={20}
          strokeColor={getValueOfTailwindVariable('--color-sky-600')}
          className="!m-0"
        />
        <Tooltip content="Remove file">
          <IconOnlyButton
            icon={<Icon.FaXmark />}
            onClick={onRemove}
            className="!text-neutral-500"
          />
        </Tooltip>
      </HStack>
    </HStack>
  )
}
